<template>
  <md-toolbar md-elevation="0" class="main-navbar md-toolbar-primary md-toolbar-absolute md-white md-fixed-top">
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <div class="logo">
          <router-link :to="{ name: defaultScreenAux }" class="simple-text logo-mini">
            <img src="/img/logo-md.png" class="simple-text logo-mini" alt="Bizminer logo" />
          </router-link>
        </div>
      </div>
      <div class="md-toolbar-section-end">
        <md-button class="md-just-icon md-round md-simple md-toolbar-toggle" :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar">btn
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="button-container main-nav-cta tour" style="margin-right: 10px">
          <div class>
            <md-button class="md-default md-block" :href="tourLink" @click="startTour">
              <i class="dark-blue-color md-icon md-icon-font md-theme-default">send</i>
              <span>Tour</span>
            </md-button>
          </div>
        </div>

        <div class="button-container main-nav-cta help" style="margin-right: 10px">
          <div class>
            <md-button class="dark-blue-color md-default md-block">
              <a href="https://support.bizminer.com/" target="_blank"><i
                  class="md-icon md-icon-font md-theme-default">help</i><span class="dark-blue-color">Help</span></a>
            </md-button>
          </div>
        </div>

        <div class="button-container main-nav-cta favorites" style="margin-right:10px; display:none;">
          <div class>
            <div class="favorite_dropmenu">
              <ul class="categories">
                <li>
                  <h5><i class="md-icon">business</i>Companies</h5>
                  <ul>
                    <li>
                      <h6><i class="md-icon">star</i>Company Profile</h6>
                      <p>Guida's Dairy CT, 6051</p>
                    </li>
                    <li>
                      <h6><i class="md-icon">star</i>Companies</h6>
                      <p>Guida's Dairy CT, 6051</p>
                    </li>
                  </ul>
                </li>
                <li>
                  <h5><i class="md-icon">business_center</i>Industries</h5>
                  <ul>
                    <li>
                      <h6><i class="md-icon">star</i>Sales per square foot</h6>
                      <p>Guida's Dairy CT, 6051</p>
                    </li>
                    <li>
                      <h6><i class="md-icon">star</i>Sales per square foot</h6>
                      <p>Guida's Dairy CT, 6051</p>
                    </li>
                  </ul>
                </li>
                <li>
                  <h5><i class="md-icon">place</i>Areas</h5>
                  <ul>
                    <li>
                      <h6><i class="md-icon">star</i>Market Areas</h6>
                      <p>Guida's Dairy CT, 6051</p>
                    </li>
                    <li>
                      <h6><i class="md-icon">star</i>Market Areas</h6>
                      <p>Guida's Dairy CT, 6051</p>
                    </li>
                  </ul>
                </li>
                <li>
                  <h5><i class="md-icon">equalizer</i>Sales Classes</h5>
                  <ul>
                    <li>
                      <h6><i class="md-icon">star</i>Sales Classes</h6>
                      <p>Guida's Dairy CT, 6051</p>
                    </li>
                    <li>
                      <h6><i class="md-icon">star</i>Sales Classes</h6>
                      <p>Guida's Dairy CT, 6051</p>
                    </li>
                  </ul>
                </li>
                <li>
                  <h5><i class="md-icon">equalizer</i>Product Types</h5>
                  <ul>
                    <li>
                      <h6>
                        <i class="md-icon">star</i>Industry Market Profile
                      </h6>
                      <p>Guida's Dairy CT, 6051</p>
                    </li>
                    <li>
                      <h6>
                        <i class="md-icon">star</i>Industry Market Profile
                      </h6>
                      <p>Guida's Dairy CT, 6051</p>
                    </li>
                  </ul>
                </li>
              </ul>
              <router-link to="/" class="showAll">
                View All
                <i class="md-icon">double_arrow</i>
              </router-link>
            </div>
          </div>
        </div>
        <!-- <div class="button-container main-nav-cta onboard">
          <div class>
            <md-button class="md-round" @click="onBoard()">
              <i class="md-icon">perm_contact_calendar</i>Onboard
            </md-button>
          </div>
        </div> -->
        <!-- <div class="button-container main-nav-cta feedback">
          <md-button class="md-round" @click="feedback()">
            <i class="md-icon">comment</i>Product Feedback
          </md-button>
        </div> -->

        <div class="button-container main-nav-cta upgrade">
          <div class>
            <md-button class="md-info md-block md-round"
              v-if="!isAcademic && !this.auth_user.user.BVR && !isEnterprise">
              <a href="https://calendly.com/gpugh/account-upgrade" target="_blank" class="href-white"
                @click="countUpdateAccountClick()">
                Upgrade Account</a>
              <i class="dark-blue-color md-icon">admin_panel_settings</i>
            </md-button>
          </div>
        </div>

        <div v-if="!isSubscriber && !isAcademic" class="button-container main-nav-cta cart" style="margin-right: 10px">
          <div class>
            <md-button class="md-default md-round">
              <router-link :to="{ name: 'Cart' }">
                <i class="md-icon md-icon-font md-theme-default">shopping_cart</i>
                <span class="count">{{ cart.length }}</span>
              </router-link>
            </md-button>
          </div>
        </div>
        <div v-if="isAcademic && ipDetected" class="button-container main-nav-cta upgrade">
          <div class>
            <md-button class="md-info md-block md-round">
              <a href="#" class="href-white" @click="logout">
                <span class="dropdown-icon">
                  <md-icon>power_settings_new</md-icon>
                </span>
                Logout
              </a>
            </md-button>
          </div>
        </div>
        <div class="md-collapse" v-if="!isAcademic || !ipDetected">
          <md-list>
            <md-list-item class="user-avatar-item">
              <drop-down class="user-dropdown"> <!-- Take the v-if out for notification to be visible -->
                <a slot="title" class="dropdown-toggle notification-icon" data-toggle="dropdown" @click="trackView()">
                  <md-avatar class="md-avatar-icon" style="background-color: #b8c3d0;">
                    <md-icon style="color: #002277;">{{
            this.newNotification.length > 0
              ? "notifications_active"
              : "notifications_none"
          }}</md-icon>
                  </md-avatar>
                  <span v-if="this.newNotification.length > 0" class="badge">{{
            this.newNotification.length
          }}</span>
                </a>
                <ul class="dropdown-menu dropdown-menu-right">
                  <li v-for="notification in this.notificationList" :key="notification.notifications_list_id">
                    <a class="dropdown-link" style="width: 100%" @click="
            getNotification(notification.notifications_list_id)
            ">
                      <md-avatar>
                        <md-icon :style="notification.read
              ? 'color: #b8c3d0;'
              : 'color: #002277;'
            ">notifications</md-icon>
                      </md-avatar>
                      <span style="width: 100%" :style="notification.read ? '' : 'font-weight: bold;'">{{
            notification.title }}</span>
                    </a>
                  </li>
                </ul>
              </drop-down>
            </md-list-item>
          </md-list>
        </div>
        <div class="md-collapse" v-if="!isAcademic || !ipDetected">
          <md-list>
            <md-list-item class="user-avatar-item">
              <drop-down class="user-dropdown">
                <a slot="title" class="dropdown-toggle" data-toggle="dropdown">
                  <avatar class="user-avatar black-color" v-if="!this.auth_user.user.avatar" :size="35" :inline="true"
                    backgroundColor="#b8c3d0" :username="this.auth_user.user.firstNameBilling +
            ' ' +
            this.auth_user.user.lastNameBilling
            "></avatar>
                  <img v-if="this.auth_user.user.avatar" class="user-avatar" :src="this.auth_user.user.avatar" />
                  <span class="usr_ttl">
                    {{ this.auth_user.user.firstNameBilling }}
                    <i class="md-icon">arrow_drop_down</i>
                  </span>
                </a>
                <ul class="dropdown-menu dropdown-menu-right">
                  <li v-if="!isAcademic && !this.auth_user.user.BVR">
                    <router-link :to="{ name: 'UserPage' }" class="dropdown-link">
                      <span class="dropdown-icon">
                        <md-icon>manage_accounts</md-icon>
                      </span>
                      My Account
                    </router-link>
                  </li>
                  <li>
                    <a href="#" class="dropdown-link" @click="logout">
                      <span class="dropdown-icon">
                        <md-icon>power_settings_new</md-icon>
                      </span>
                      Logout
                    </a>
                  </li>
                </ul>
              </drop-down>
            </md-list-item>
          </md-list>
        </div>
      </div>
      <modal v-if="onBoardModal" @close="onBoardModal = false" class="onboard_modal"
        :class="{ no_footer: !onboardFooter }">
        <template slot="header">
          <!--<div class="onboard_img">
            <img src="/img/onboard1.png" alt />
          </div> -->
          <div class="onboard_info">
            <!--<h2>
              Bizminer 2.0
              <span>Onboarding...</span>
            </h2> -->
            <h5>{{ onboardScreen }}</h5>
            <ProgressBar :scale="progress" />
            <ul class="step_indiactors" :class="stepIndiactors ? `${stepIndiactors}` : ''">
              <li :class="{ active: step1 }">Agree to Terms &amp; Policies.</li>
              <li :class="{ active: step2 }">Personalization</li>
              <li :class="{ active: step3 }">Company Information</li>
              <li :class="{ active: step4 }">Invite Team</li>
              <li :class="{ active: step5 }">Support Contact</li>
            </ul>
          </div>
        </template>
        <template slot="body">
          <div class="step_content" v-if="step0">
            <h1>
              Welcome to Bizminer,
              <span>{{ billingFirstname }} !</span>
            </h1>
            <h5>
              Just a few customization items to help get the most out of your
              Bizminer account.
            </h5>
            <!-- <img src="/img/onboard-welcome.png" alt />-->
            <md-button class="md-round getStarted_btn" @click="getStarted">Get Started</md-button>
          </div>
          <div class="step_content" v-if="step1" id="terms">
            <!-- <md-button class="contract md-round">
              <md-icon>gavel</md-icon>View Contract
            </md-button>-->
            <Terms />
            <!-- <Privacy/> -->
          </div>
          <div class="step_content" v-if="step2">
            <h3>Personalization</h3>
            <p>
              Please identify your sector, sub-sector, and job function.
            </p>
            <div class="field_wpr">
              <md-field :class="{ 'md-invalid': $v.industry2.$error }">
                <label>Sector:</label>
                <md-select v-model="$v.industry.$model">
                  <md-option v-for="industry in industries" :key="industry.label" :value="industry.label">{{
            industry.label }}</md-option>
                </md-select>
                <span class="md-error" v-if="!$v.industry2.required">This field is required.</span>
              </md-field>
              <md-field>
                <label>Sub Sector:</label>
                <md-input v-model="$v.subSector.$model"></md-input>
              </md-field>
              <md-field :class="{ 'md-invalid': $v.jobTitle.$error }">
                <label>Job Function:</label>
                <md-input type="text" v-model="$v.jobTitle.$model"></md-input>
                <span class="md-error" v-if="!$v.jobTitle.required">This field is required.</span>
              </md-field>
            </div>
            <!--<div class="box_info">
              <img src="/img/billing.png" alt />
              <div class="box_section">
                <h4>Preferences</h4>
                <p>
                  Duis posuere convallis lacus ac suscipit. Integer nulla massa,
                  varius quis eros sagittis, condimentum blandit velit.
                </p>
                <div class="avatar_wpr">
                  <div class="profile_avatar">
                    <img class="img" :src="avatar" @click="$refs.imgUpload.click()" v-if="avatar" />
                    <div class="edit-user-avatar" @click="$refs.imgUpload.click()">
                      <md-icon>edit</md-icon>
                    </div>
                    <input style="display:none" type="file" name="avatar" @change="onFileChange" ref="imgUpload" />
                  </div>
                  <div class="avatar_info">
                    <h4 class="avatar_name">
                      {{ billingFirstname ? billingFirstname : '' }}
                      {{ billingLastname ? billingLastname : '' }}
                    </h4>
                    <h6 class="avatar_role">{{ this.myTitle }}</h6>
                  </div>
                </div>
                <div class="field_wpr">
                  <md-field :class="{ 'md-invalid': $v.defaultScreen.$error }">
                    <label>
                      Default Screen
                      <i class="md-icon">help</i>
                    </label>
                    <md-select v-model="$v.defaultScreen.$model" name="defaultScreen">
                      <md-option v-for="defaultScreen in defaultScreens" :key="defaultScreen.path"
                        :value="defaultScreen.path">{{ defaultScreen.name }}</md-option>
                    </md-select>
                    <span class="md-error" v-if="!$v.defaultScreen.required">This field is required.</span>
                  </md-field>
                </div>
                <div class="field_wpr">
                  <md-field :class="{ 'md-invalid': $v.jobTitle.$error }">
                    <label>Favorite Industry :</label>
                    <md-input type="text" v-model="$v.jobTitle.$model"></md-input>
                    <span class="md-error" v-if="!$v.jobTitle.required">This field is required.</span>
                  </md-field>
                  <md-field :class="{ 'md-invalid': $v.jobTitle.$error }">
                    <label>Favorite Area :</label>
                    <md-input type="text" v-model="$v.jobTitle.$model"></md-input>
                    <span class="md-error" v-if="!$v.jobTitle.required">This field is required.</span>
                  </md-field>
                </div>
              </div>
            </div>-->
          </div>
          <div class="step_content" v-if="step3">
            <h3>Company Information</h3>

            <div class="box_info">
              <!--<img src="/img/billing.png" alt />-->
              <div class="box_section">
                <p>
                  Here you can set your company details and logo for use on
                  Bizminer Reports.
                </p>
                <div class="avatar_wpr">
                  <div class="profile_avatar">
                    <img class="img" :src="companyLogo" @click="$refs.compImgUpload.click()" v-if="companyLogo" />
                    <div class="edit-user-avatar" @click="$refs.compImgUpload.click()">
                      <md-icon>edit</md-icon>
                    </div>
                    <input aria-label="Company logo" style="display:none" type="file" name="companyLogo"
                      @change="onCompanyChange" ref="compImgUpload" />
                  </div>
                  <div class="avatar_info">
                    <h4 class="avatar_name">
                      {{ companyName ? companyName : "Company Name" }}
                    </h4>
                    <h6 class="avatar_role">
                      {{ companyAddress ? companyAddress + "," : "" }}
                      {{ companyCity ? companyCity + "," : "" }}
                      {{ companyState.name ? companyState.name + "," : "" }}
                      {{ companyZip ? companyZip + "," : "" }}
                      {{ companyCountry ? companyCountry : "" }}
                    </h6>
                  </div>
                </div>
                <div class="field_wpr">
                  <md-field :class="{ 'md-invalid': $v.companyName.$error }">
                    <label>
                      Company Name
                      <i class="md-icon">help</i>
                    </label>
                    <md-input v-model="$v.companyName.$model" type="text"></md-input>
                    <span class="md-error" v-if="!$v.companyName.required">This field is required.</span>
                  </md-field>
                  <md-field :class="{ 'md-invalid': $v.companyAddress.$error }">
                    <label>
                      Company Address
                      <i class="md-icon">help</i>
                    </label>
                    <md-input v-model="$v.companyAddress.$model" type="text"></md-input>
                    <span class="md-error" v-if="!$v.companyAddress.required">This field is required.</span>
                  </md-field>
                  <md-field :class="{ 'md-invalid': $v.companyCity.$error }">
                    <label>
                      Company City
                      <i class="md-icon">help</i>
                    </label>
                    <md-input v-model="$v.companyCity.$model" type="text"></md-input>
                    <span class="md-error" v-if="!$v.companyCity.required">This field is required.</span>
                  </md-field>
                  <md-field :class="{ 'md-invalid': $v.companyState.$error }">
                    <label>
                      Company State
                      <i class="md-icon">help</i>
                    </label>
                    <md-select v-model="$v.companyState.$model" name="companyState">
                      <md-option v-for="state in states" :key="state" :value="state">{{ state.name }}</md-option>
                    </md-select>
                    <span class="md-error" v-if="!$v.companyState.required">This field is required.</span>
                  </md-field>
                  <md-field :class="{ 'md-invalid': $v.companyZip.$error }">
                    <label>
                      Company Zip/Postal
                      <i class="md-icon">help</i>
                    </label>
                    <md-input v-model="$v.companyZip.$model" type="text"></md-input>
                    <span class="md-error" v-if="!$v.companyZip.required">This field is required.</span>
                  </md-field>
                  <md-field :class="{ 'md-invalid': $v.companyCountry.$error }">
                    <label>
                      Company Country
                      <i class="md-icon">help</i>
                    </label>
                    <md-select aria-label="Company country" v-model="$v.companyCountry.$model" name="companyCountry">
                      <md-option v-for="country in countries" :key="country.code" :value="country.code">{{ country.name
                        }}</md-option>
                    </md-select>
                    <span class="md-error" v-if="!$v.companyCountry.required">This field is required.</span>
                  </md-field>
                </div>
              </div>
            </div>
          </div>
          <div class="step_content" v-if="step4">
            <h3>Your Team</h3>
            <p class="note">
              Invite up to 10 team members now. Team management is located in
              the Account/My Team section.
            </p>
            <div class="box_info">
              <img src="/img/billing.png" alt />
              <div class="box_section">
                <h4>Invite Your Team</h4>
                <p>
                  Add your team members below. They will receive an email to
                  activate their account. You can skip this and do it later from
                  the My Account/Team section.
                </p>
                <div class="field_wpr">
                  <md-field :class="{ 'md-invalid': $v.memberFirstname.$error }">
                    <label>First Name:</label>
                    <md-input type="text" v-model="$v.memberFirstname.$model"></md-input>
                  </md-field>
                  <md-field :class="{ 'md-invalid': $v.memberLastname.$error }">
                    <label>Last Name:</label>
                    <md-input type="text" v-model="$v.memberLastname.$model"></md-input>
                  </md-field>
                  <md-field :class="{ 'md-invalid': $v.memberEmail.$error }">
                    <label>E-mail Address:</label>
                    <md-input type="text" v-model="$v.memberEmail.$model"></md-input>
                  </md-field>
                </div>
                <div class="py-4">
                  <md-button class="md-info md-round" @click="addTeamMember">
                    <md-icon>person_add</md-icon>Add Member
                  </md-button>
                </div>
              </div>
            </div>
            <div v-if="addMember.length > 0">
              <h4>Added Member</h4>
              <ul class="member_list">
                <li v-for="member in addMember" :key="member.fName">
                  <span>
                    <md-icon>account_circle</md-icon>
                    {{ member.fName + " " + member.lName }}
                  </span>
                  <span>
                    <md-icon>mail_outline</md-icon>
                    {{ member.eMail }}
                  </span>
                  <md-button class="md-danger">
                    <md-icon>delete_outline</md-icon>
                  </md-button>
                </li>
              </ul>
            </div>
          </div>
          <div class="step_content" v-if="step5">
            <div class="support">
              <div class="img_wpr">
                <img src="/img/taylor-rudnik.jpg" alt />
              </div>
              <div class="support_info">
                <h3>Support Contact</h3>
                <h5>Taylor Rudnick</h5>
                <ul>
                  <li>
                    <md-icon>mark_as_unread</md-icon>trudnick@bizminer.com
                  </li>
                  <li><md-icon>phone_in_talk</md-icon>(717) 909-6000</li>
                </ul>
              </div>
            </div>
            <div class="complete_info">
              <!-- <h1>
                Hey,
                <span>{{ billingFirstname }} !</span>
              </h1>
              <h3>
                <md-icon>verified</md-icon>You have Completed Bizminer 2.0
                Onboarding Successfully
              </h3>
              <img src="/img/onboard-complete.png" alt /> -->
              <div class="action_wpr">
                <md-button class="md-tertiary md-round" @click="
            userflow.start('96869bce-fcf9-4df7-a5b3-ae14b0b285dc')
            " v-if="isAcademic">Launch Tour</md-button>

                <md-button class="md-tertiary md-round" @click="
            userflow.start('bef3267f-0f6e-44d9-a9d7-9bc101e2567a')
            " v-else>Launch Tour</md-button>

                <md-button class="md-tertiary md-round" href="https://support.bizminer.com/" target="_blank"
                  @click="onBoardModal = false">Support Site</md-button>
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <md-checkbox v-model="acceptTermPolicy" v-if="step1">I accept the Terms of Service &amp; Privacy Policy.
          </md-checkbox>
          <md-button class="md-round back_btn" @click="back_btn" v-if="backBtn">Back</md-button>
          <div class="action_wpr">
            <md-button class="md-info md-round" @click="onBoardModal = false" v-if="escBtn">Continue Later</md-button>
            <md-button class="md-primary md-round" @click="continue_btn" v-if="nextBtn">
              Next
              <md-icon>arrow_right_alt</md-icon>
            </md-button>
            <md-button class="md-primary md-round" @click="onBoardModal = false" v-if="!nextBtn">Access the Product
            </md-button>
          </div>
        </template>
      </modal>
      <modal v-if="upgradeModal" @close="upgradeModal = false" class="upgradeAcc">
        <template slot="header">
          <div class="representative">
            <div class="img_wpr">
              <img src="/img/taylor-rudnik.jpg" alt />
            </div>
            <h4>Taylor Rudnick</h4>
            <h6>Account Representative</h6>
          </div>
        </template>
        <template slot="body">
          <button type="button" class="close_btn" @click="upgradeModal = false">
            <md-icon>clear</md-icon>
          </button>
          <h3 class="modal-title">Upgrade Account</h3>
          <p>
            To upgarde account you need to submit this form to your account
            representative.
          </p>
          <form action class="form_grp">
            <div class="field_wpr">
              <label for>Leave A Note</label>
              <textarea placeholder="Type a message"></textarea>
              <md-button class="md-info md-round mt-4">Upgrade Request</md-button>
            </div>
          </form>
        </template>
      </modal>
    </div>
  </md-toolbar>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { Modal, ProgressBar } from "@/components";
import { required, email } from "vuelidate/lib/validators";
import Terms from "@/pages/Bizminer/Terms.vue";
import Avatar from "vue-avatar";
import axios from "axios";
import userflow from "userflow.js";

import {
  countryList,
  localStates,
  localTimeZones,
} from "@/assets/common/location";

export default {
  name: "main-navbar",
  components: {
    Modal,
    Terms,
    ProgressBar,
    Avatar,
  },
  data() {
    return {
      selectedEmployee: "",
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone",
      ],
      ipDetected: false,
      tourLink: "#",
      helpLink: "https://support.bizminer.com/",
      dashboardUrl: "/dashboard",
      preference: undefined,
      avatar: null,
      userImage: null,
      userName: null,
      upgradeModal: false,
      onBoardModal: false,
      legalname: null,
      billingFirstname: null,
      billingLastname: null,
      billingEmail: null,
      billingPhoneNumber: null,
      accountFirstname: null,
      accountLastname: null,
      accountEmail: null,
      accountPhoneNumber: null,
      industries: null,
      jobTitle: null,
      rootScreen: null,
      dateFormat: null,
      timeFormat: null,
      timeZone: null,
      defaultScreen: null,
      defaultScreens: [
        { name: "Search", path: "Search" },
        { name: "New Industry Financial Profile", path: "NewProfile" },
        { name: "New Industry Market Profile", path: "NewMarketProfile" },
        { name: "New Company Profile", path: "FindCompanies" },
        { name: "New Company List", path: "ProspectList" },
        { name: "Benchmarking Tool", path: "NewReport" },
        { name: "Valuation Multiple", path: "ValuationMultiple" },
        { name: "My Data", path: "MyData" },
        { name: "Subscription Activity", path: "Subscriptions" },
      ],
      dateFormats: ["MM/DD/YYYY", "DD/MM/YYYY", "YYYY/MM/DD"],
      timeFormats: ["12h AM/PM", "24h"],
      industry: null,
      industry2: null,
      subSector: null,
      myTitle: null,
      file: null,
      companyFile: null,
      companyName: null,
      companyAddress: null,
      companyCity: null,
      companyState: null,
      companyZip: null,
      companyCountry: null,
      companyLogo: "/img/product-placeholder.gif",
      countries: countryList,
      states: localStates,
      timeZones: localTimeZones,
      memberFirstname: "",
      memberLastname: "",
      memberEmail: "",
      step0: true,
      step1: false,
      step2: false,
      step3: false,
      step4: false,
      step5: false,
      step6: false,
      onboardScreen: "Please Complete All The Steps.",
      stepIndiactors: null,
      acceptTermPolicy: false,
      addMember: [],
      introMail: false,
      onboardFooter: false,
      backBtn: false,
      escBtn: false,
      nextBtn: true,
      progress: 0,
      userDataLoaded: false,
      hotjarSent: false,
      userFlowCount: 0,
    };
  },
  validations: {
    legalname: {
      required,
    },
    billingFirstname: {
      required,
    },
    billingLastname: {
      required,
    },
    billingEmail: {
      required,
      email,
    },
    billingPhoneNumber: {
      required,
    },
    accountFirstname: {
      required,
    },
    accountLastname: {
      required,
    },
    accountEmail: {
      required,
      email,
    },
    accountPhoneNumber: {
      required,
    },
    jobTitle: {
      required,
    },
    rootScreen: {
      required,
    },
    dateFormat: {
      required,
    },
    timeFormat: {
      required,
    },
    timeZone: {
      required,
    },
    defaultScreen: {
      required,
    },
    dateFormats: {
      required,
    },
    timeFormats: {
      required,
    },
    industry: {
      required,
    },
    industry2: {
      required,
    },
    subSector: {
      required,
    },
    myTitle: {
      required,
    },
    companyName: {
      required,
    },
    companyAddress: {
      required,
    },
    companyCity: {
      required,
    },
    companyState: {
      required,
    },
    companyZip: {
      required,
    },
    companyCountry: {
      required,
    },
    companyLogo: {
      required,
    },
    memberFirstname: {
      required,
    },
    memberLastname: {
      required,
    },
    memberEmail: {
      required,
      email,
    },
  },
  computed: {
    ...mapGetters({
      notificationList: "notificationList",
      newNotification: "countNewNotification",
    }),
    ...mapState({
      auth_user: (state) => state.user,
      user: (state) => state.user.user,
      defaultScreenAux: (state) =>
        state?.user?.user?.preferences?.defaultScreen
          ? state?.user?.user?.preferences?.defaultScreen.replace(/ /g, "")
          : "Search",
      cart: (state) => state.cart.cart,
      subTotal: (state) => state.cart.subTotal,
      total: (state) => state.cart.total,
      isSubscriber: (state) => state?.user?.user_type?.subscriber ?? null,
      isAcademic: (state) => state?.user?.user_type?.academic ?? null,
      isRetail: (state) =>
        state?.user?.user_type?.retail/* || state.user.allow_retail*/ ? true : null,
      isEnterprise: (state) => state?.user?.user_type?.enterprise ?? null,
    }),
  },
  watch: {
    user() {
      if (this.user && this.userFlowCount === 0) {
        this.userFlowCount++;
        this.userFlow();
      }
      if (!this.userDataLoaded && !this.isRetail) {
        setTimeout(() => {
          this.delightedSurvey();
          this.userFlow();
        }, 1000);
      }
      if (!this.hotjarSent) {
        this.hotJar();
      }
      this.userDataLoaded = true;
    },
    isAcademic(val) {
      if (val && !this.userDataLoaded) {
        setTimeout(() => {
          this.delightedSurvey();
          this.userFlow();
        }, 1000);
      }
      this.userDataLoaded = true;
    },
  },
  methods: {
    ...mapActions({
      countUpdateAccount: "tracking/countUpdateAccount",
      showNotification: "showNotification",
      trackView: "trackView",
    }),
    async getNotification(notification_id) {
      this.showNotification({
        notification_id: notification_id,
      });
    },
    countUpdateAccountClick() {
      this.countUpdateAccount({ userId: this.auth_user?.user?.userID });
    },
    async getAuth() {
      try {
        this.$store.dispatch("authenticateUser").then((res) => {
          if (res && res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
            throw new Error(
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
          }
          if (res !== undefined) {
            if (res) {
              this.billingFirstname = res.firstNameBilling;
              this.billingLastname = res.lastNameBilling;
              this.billingEmail = res.emailBilling;
              this.billingPhoneNumber = res.phoneNumber;
              this.address = res.streetAddr;
              this.city = res.city;
              this.stateProvince = res.state;
              this.code = res.zip;
              this.country = res.country;
              this.defaultScreen = res.preferences.defaultScreen
                ? res.preferences.defaultScreen
                : "Search";
              this.dateFormat = res.preferences.dateFormat
                ? res.preferences.dateFormat
                : "MM/DD/YYYY";
              this.timeFormat = res.preferences.timeFormat
                ? res.preferences.timeFormat
                : "12h AM/PM";
              this.timeZone = res.preferences.timezone
                ? res.preferences.timezone
                : "EST";
              this.industry = res.preferences.industry;
              this.myTitle = res.preferences.title;
              this.companyName = res.companyName;
              this.companyAddress = res.companyAddress;
              this.companyCity = res.companyCity;
              this.companyState = res.companyState;
              this.companyZip = res.companyZip;
              this.companyCountry = res.companyCountry;
              this.avatar = res.avatar ? res.avatar : "";
              this.companyLogo = res.companyLogo ? res.companyLogo : "";
              this.$store.commit("user/SET_USER", res, { root: true });
              this.$store.commit(
                "user/SET_HOME",
                res.preferences.defaultScreen
              );
            }
          }
        });
      } catch (e) {
        this.$store.dispatch("alerts/error", "We can't get data for this user");
      }
    },
    getGeneralInfo() {
      try {
        this.$store.dispatch("profile/getGenInfo").then((res) => {
          if (res && res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
            throw new Error(
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
          }
          this.industries = res.job_functions;
          this.myTitles = res.title_codes;
        });
      } catch (e) { }
    },
    onBoard() {
      this.onBoardModal = true;
    },
    startTour() {
      this.userFlow();

      /*if (this.auth_user.user_type.academic) {
        userflow.start("96869bce-fcf9-4df7-a5b3-ae14b0b285dc");
      } else {*/
      userflow.start("90c4d553-b5cf-41e2-b6d1-13c816e51235");
      //}
      this.onBoardModal = false;
    },
    getStarted() {
      this.step0 = false;
      this.step1 = true;
      this.onboardFooter = true;
    },
    continue_btn() {
      if (this.step1 && this.acceptTermPolicy) {
        this.step1 = false;
        this.step2 = true;
        this.escBtn = true;
        (this.backBtn = true),
          (this.progress = 25),
          (this.stepIndiactors = "firstStep");
      } else if (this.step2) {
        this.step2 = false;
        this.step3 = true;
        (this.progress = 50), (this.stepIndiactors = "secondStep");
      } else if (this.step3) {
        this.step3 = false;
        this.step4 = true;
        (this.progress = 75), (this.stepIndiactors = "thirdStep");
        this.onboardScreen = "You Are Almost There!";
      } else if (this.step4) {
        this.step4 = false;
        this.step5 = true;
        this.nextBtn = false;
        this.escBtn = false;
        (this.progress = 100), (this.stepIndiactors = "forthStep");
        this.onboardScreen = "You Are All Set!";
      }
    },
    back_btn() {
      if (this.step2) {
        this.step2 = false;
        this.step1 = true;
        this.backBtn = false;
        this.stepIndiactors = null;
        this.progress = 0;
      }
      if (this.step3) {
        this.step3 = false;
        this.step2 = true;
        this.stepIndiactors = "firstStep";
        this.progress = 25;
      }
      if (this.step4) {
        this.step4 = false;
        this.step3 = true;
        this.stepIndiactors = "secondStep";
        this.progress = 50;
      }
      if (this.step5) {
        this.step5 = false;
        this.step4 = true;
        this.stepIndiactors = "thirdStep";
        this.onboardScreen = "You Are Almost There!";
        this.progress = 75;
      }
    },
    addTeamMember() {
      this.addMember.push({
        fName: this.memberFirstname,
        lName: this.memberLastname,
        eMail: this.memberEmail,
      });
      this.memberFirstname = "";
      this.memberLastname = "";
      this.memberEmail = "";
    },
    modalFunc() {
      this.upgradeModal = true;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    goToNotifications() {
      this.$router.push({ name: "Notifications" });
    },
    goToUsers() {
      this.$router.push({ name: "User Page" });
    },
    logout() {
      this.$store.commit("SET_PRODUCT_TYPE", null);
      this.removeCarItems();
    },
    async removeCarItems() {
      await this.$store.dispatch("cart/list").then((res) => {
        res.items.forEach((elem) => {
          this.removeCartItem(elem.id);
        });
        this.$store.dispatch("logout");
      });
    },
    async removeCartItem(id) {
      let params = {
        product_id: id,
      };
      await this.$store.dispatch("cart/removeItem", params).then((res) => { });
    },
    getPreference() {
      this.$store.dispatch("authenticateUser").then((res) => {
        if (res) {
          this.$store.commit("user/SET_USER", res, { root: true });
          this.$store.commit("user/SET_HOME", res.preferences.defaultScreen);
        }
      });
    },
    onFileChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    onCompanyChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.createCompanyImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.avatar = e.target.result;
        this.file = file;
      };
      reader.readAsDataURL(file);
    },
    createCompanyImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.companyLogo = e.target.result;
        this.companyFile = file;
      };
      reader.readAsDataURL(file);
    },
    getCart() {
      this.$store.dispatch("cart/list");
    },
    delightedSurvey: function () {
      let products = "";
      if (
        this.auth_user &&
        this.auth_user.user_subscriptions &&
        this.auth_user.user_subscriptions &&
        !this.isAcademic
      ) {
        for (const sub of this.auth_user.user_subscriptions) {
          products = products + sub + ", ";
        }
        products = "";
      }

      let userType = "";
      if (this.auth_user && this.auth_user.user_type) {
        if (this.auth_user.user_type.academic) {
          userType = "academic, ";
        }
        if (this.auth_user.user_type.enterprise) {
          userType = userType + "enterprise, ";
        }
        if (this.auth_user.user_type.subscriber) {
          userType = userType + "subscriber, ";
        }
        if (this.auth_user.user_type.retail) {
          userType = "retail";
        }
      }

      let companyName = "";
      if (
        this.auth_user &&
        this.auth_user.user &&
        this.auth_user.user.companyName
      ) {
        companyName = this.auth_user.user.companyName;
      }

      delighted.survey({
        email: this.auth_user?.user?.email, // the customers email address
        name:
          this.auth_user?.user?.firstName +
          " " +
          this.auth_user?.user?.lastName, // customer full name
        createdAt: "", // if a subscriber, the start date (check with Ray for API call for this)
        properties: {
          products: products,
          user_type: userType,
          company: companyName,
        },
      });
    },
    userFlow: function () {
      let userID = this.auth_user?.user?.userID;
      if (this.isAcademic) {
        userID = this.auth_user?.user?.ipID;
        // BUG, ipID not defined, setting random placeholder
        if(!userID) {
          userID = 12746217868127461249;
        }
      }
      userflow.init("ct_et6zbdszcrd6zl554mzzvn2ps4");
      userflow.identify(userID, {
        name:
          this.auth_user?.user?.firstName +
          " " +
          this.auth_user?.user?.lastName,
        email: this.auth_user?.user?.email,
        signed_up_at: this.auth_user?.signed_up_at,
        academic: this.auth_user?.userType?.academic,
      });
    },
    hotJar: function () {
      let userID = this.auth_user?.user?.userID;
      if (this.isAcademic) {
        userID = this.auth_user?.user?.ipID;
        // BUG, ipID not defined, setting random placeholder
        if(!userID) {
          userID = 12746217868127461249;
        }
      }

      window.hj("identify", userID, {
        // Add your own custom attributes here. Some EXAMPLES:
        email: this.auth_user?.user?.email, // email address
        name:
          this.auth_user?.user?.firstName +
          " " +
          this.auth_user?.user?.lastName, // first and last name
        signed_up_at: this.auth_user?.signed_up_at,
        academic: this.auth_user?.userType?.academic,
      });

      this.hotjarSent = true;
    },
  },
  async mounted() {
    let academicIP = localStorage.getItem("academicIP");
    if (academicIP) this.ipDetected = true;

    await this.getAuth();
    this.getPreference();
    this.userDataLoaded = true;

    // bugpilot flow:

    /*window.Bugpilot.identify({
      id: this.auth_user.user.userID, // Required. Replace with actual user id.
      email: this.auth_user.user.email, // Required. Replace with actual user email.
      // Optional:
      firstName: this.auth_user.user.firstName,
      lastName: this.auth_user.user.lastName
    });*/

    //this.delightedSurvey();
  },
  created() {
    this.getGeneralInfo();
    this.getCart();
  },
};

!(function (e, t, r, n) {
  if (!e[n]) {
    for (
      var a = (e[n] = []),
      i = [
        "survey",
        "reset",
        "config",
        "init",
        "set",
        "get",
        "event",
        "identify",
        "track",
        "page",
        "screen",
        "group",
        "alias",
      ],
      s = 0;
      s < i.length;
      s++
    ) {
      var c = i[s];
      a[c] =
        a[c] ||
        (function (e) {
          return function () {
            var t = Array.prototype.slice.call(arguments);
            a.push([e, t]);
          };
        })(c);
    }
    a.SNIPPET_VERSION = "1.0.1";
    var o = t.createElement("script");
    (o.type = "text/javascript"),
      (o.async = !0),
      (o.src =
        "https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/" +
        r +
        "/" +
        n +
        ".js");
    var p = t.getElementsByTagName("script")[0];
    p.parentNode.insertBefore(o, p);
  }
})(window, document, "vjY2DCbUpHFJn6LL", "delighted");
</script>
